var _circle, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMatchedRound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 14.5,
    stroke: "#D9622A"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_11585_284963",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 2,
    width: 28,
    height: 28
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1277 29.0243L28.3619 15.8283L15.1659 2.59405L1.93168 15.7901L15.1277 29.0243Z",
    fill: "currentColor",
    stroke: "white",
    strokeWidth: 0.5
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_11585_284963)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.1832 14.4825C15.9758 14.47 15.778 14.5049 15.5994 14.5775C15.3847 14.6648 15.1505 14.5038 15.1508 14.2721L15.1533 12.55C15.1544 11.8048 14.5512 11.1999 13.8061 11.1988L12.084 11.1963C11.8522 11.196 11.6919 10.9613 11.7798 10.7469C11.853 10.5685 11.8885 10.3708 11.8765 10.1634C11.8382 9.50101 11.3049 8.96038 10.643 8.91387C9.8648 8.85916 9.21592 9.47371 9.21479 10.2405C9.21456 10.4174 9.24884 10.5863 9.31127 10.7408C9.39857 10.9567 9.23978 11.1922 9.00688 11.1919L7.28477 11.1894C6.53961 11.1883 5.93466 11.7915 5.93359 12.5367L5.93113 14.2548C5.93077 14.4854 6.16311 14.6467 6.37726 14.5612C6.55569 14.4899 6.75312 14.4561 6.95981 14.4695C7.61961 14.5124 8.1553 15.0463 8.19985 15.7061C8.25242 16.4845 7.63596 17.1317 6.86909 17.1306C6.69519 17.1304 6.52915 17.0968 6.37696 17.036C6.16142 16.9498 5.927 17.1076 5.92666 17.3397L5.92417 19.0579C5.92307 19.8031 6.52627 20.408 7.27143 20.4091L8.98957 20.4116C9.22018 20.4119 9.38151 20.1796 9.29596 19.9654C9.22469 19.787 9.19092 19.5896 9.20434 19.3829C9.24714 18.7231 9.78112 18.1874 10.4408 18.1428C11.2193 18.0903 11.8665 18.7067 11.8654 19.4736C11.8651 19.6475 11.8316 19.8135 11.7708 19.9657C11.6846 20.1813 11.8424 20.4157 12.0745 20.4161L13.7927 20.4185C14.5379 20.4196 15.1428 19.8164 15.1439 19.0713L15.1464 17.3491C15.1467 17.1162 15.3827 16.9581 15.5983 17.046C15.7526 17.1089 15.9214 17.1437 16.0983 17.144C16.8651 17.1451 17.4815 16.498 17.4291 15.7196C17.3845 15.0576 16.8454 14.5227 16.1832 14.4825Z",
    stroke: "currentColor",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3403 20.4283L21.2896 20.4268C21.0579 20.4264 20.8969 20.6607 20.9841 20.8753C21.0567 21.0539 21.0917 21.2517 21.0791 21.4591C21.0389 22.1214 20.504 22.6604 19.842 22.705C19.0637 22.7575 18.4166 22.1411 18.4177 21.3742C18.4179 21.1973 18.4527 21.0286 18.5156 20.8742C18.6035 20.6586 18.4454 20.4226 18.2125 20.4223L16.4904 20.4198C15.7452 20.4187 15.142 19.8138 15.1431 19.0686",
    stroke: "currentColor",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.154 12.5508C15.1551 11.8057 15.7601 11.2025 16.5052 11.2036L18.2234 11.206C18.454 11.2064 18.6146 11.4392 18.5285 11.6531C18.4567 11.8313 18.4223 12.0286 18.4351 12.2353C18.4761 12.8953 19.0084 13.4325 19.668 13.479C20.4463 13.5338 21.0954 12.9192 21.0965 12.1523C21.0967 11.9784 21.0636 11.8123 21.0033 11.66C20.9177 11.4442 21.0762 11.2102 21.3083 11.2105L23.0265 11.213C23.7716 11.2141 24.3748 11.819 24.3737 12.5642L24.3713 14.2863C24.3709 14.5192 24.6064 14.678 24.8223 14.5907C24.9768 14.5282 25.1457 14.494 25.3226 14.4942C26.0894 14.4953 26.704 15.1442 26.6492 15.9224C26.6027 16.5843 26.0621 17.1176 25.3997 17.1559C25.1924 17.1679 24.9946 17.1324 24.8163 17.0592C24.6018 16.9713 24.3671 17.1316 24.3668 17.3634L24.3654 18.3785",
    stroke: "currentColor",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMatchedRound);
export default __webpack_public_path__ + "static/media/matched-round.04f243d93b08528f7c23bffdcfb8ff52.svg";
export { ForwardRef as ReactComponent };